module.exports = __webpack_public_path__ + "6e237cfe4fef0d5d2e7921d84a46a69a.svg";